import { render, staticRenderFns } from "./RequisiteSimpleRule.vue?vue&type=template&id=50b94542&scoped=true"
import script from "./RequisiteSimpleRule.vue?vue&type=script&lang=js"
export * from "./RequisiteSimpleRule.vue?vue&type=script&lang=js"
import style0 from "./RequisiteSimpleRule.vue?vue&type=style&index=0&id=50b94542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b94542",
  null
  
)

export default component.exports